import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const LeftArrow = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.207 13.0001L11.207 17.0001L10.4999 17.7072L5.2928 12.5001L10.4999 7.29297L11.207 8.00008L7.207 12.0001H18V13.0001H7.207Z"
      fill="currentColor"
    />
  </svg>,
  'LeftArrow'
);
